// src/pages/TestPage.js
import React from "react";
import StatusTestSuite from "./TestStatusSuite";

const TestPage = () => {
  return (
    <div>
      <StatusTestSuite />
    </div>
  );
};

export default TestPage;